/* eslint-disable import/prefer-default-export */

import bridge from '@/utils/bridge';

export function getUserTokenFromSession(sessionId) {
  return bridge.ask(`Session_${sessionId}`, 'getMetaToken');
}
